export enum EPromoType {
  /** Бонусы **/
  Bonus = 'bonus',
  /** Циан ипотека **/
  CianMortgage = 'cianMortgage',
  /** Скидки **/
  Discount = 'discount',
  /** Материнский капитал **/
  MaternalCapital = 'maternalCapital',
  /** Военная ипотека **/
  Military = 'military',
  /** Ипотека **/
  Mortgage = 'mortgage',
  /** Рассрочка **/
  'Installment' = 'installment',
}
